
import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import DOMPurify from 'dompurify';
import Partenaire from '../home/Partenaire';
import { Link } from 'react-router-dom';
interface UiBasic {
  id?: number;
  apropos?: string;
  travail?: string;
  don?: string;
  structuregestion?: string;
  financement?: string;
  carriere?: string;
  partenariat?: string;
  createdAt?: string;
  updatedAt?: string;
}


interface Site {
  id?: number;
  nom?: string;
  description?: string;
  email?: string;
  adresse?: string;
  tel1?: string;
  tel2?: string;
  tel3?: string;
  token?: string;
  about?: string;
  mission?: string;
  objectif?: string;
  politique?: string;
  condition?: string;
  logo?: string;
  logoFile?: File;
  facebook?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  whatsapp?: string;
  createdAt?: string;
  updatedAt?: string;
}
export default function PartenariatShip() {
  const [sites, setSites] = useState<Site[]>([]);
  const [basic, setBasic] = useState<UiBasic[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const fetchListBasic = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<UiBasic>('/fetch_info_basic_data');
      setBasic(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }



  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<Site>('/fetch_data_site');
      setSites(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    document.title = "Partenariat - Ouragan academy";
    fetchListBasic();
    fetchData();
  }, []);
  return (


    <div className="col-md-12 col-lg-12 col-sm-12 col-12">

      {basic.length === 0 ? (
        <LoaderAndError
          loading={loading}
          error={error}
          onClearError={() => setError(null)}
        />
      ) : (
        basic.map((item, index) => (
          <div className="col-md-12" key={index}>
            <div className="container py-5">

              {/* TITRE */}
              <div className="text-center mb-4">
                <h2 className="display-10 fw-bold">
                  <span className="text-primary">Partenariats</span> & Collaborations
                </h2>
              </div>

              {/* INTRO */}
              <p className="lead text-center text-muted mb-5">
                Ouragan Academy croit en la puissance des alliances pour renforcer l’impact
                social, sportif et éducatif auprès des jeunes. Ensemble, nous construisons
                des opportunités, inspirons des vocations et accompagnons une nouvelle génération
                de leaders congolais.
              </p>

              {/* TYPES DE PARTENARIAT */}
              <div className="row g-4 mb-5">

                {/* Partenariat sportif */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-primary rounded-4">
                    <div className="icon mb-3 text-white fs-1">
                      <i className="fas fa-basketball-ball"></i>
                    </div>
                    <h5 className="fw-bold text-white">Partenariats Sportifs</h5>
                    <p className="text-white">
                      Collaboration avec clubs, académies, fédérations et coachs pour
                      renforcer l’entraînement, développer la performance et promouvoir le talent local.
                    </p>
                    <br />
                  </div>
                </div>

                {/* Partenariat humanitaire & ONG */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-dark text-white rounded-4">
                    <div className="icon mb-3 text-white fs-1">
                      <i className="fas fa-hand-holding-heart"></i>
                    </div>
                    <h5 className="fw-bold text-white">Partenariats Humanitaires</h5>
                    <p className="text-white">
                      Coopération avec ONG, associations et fondations pour accompagner
                      les jeunes des zones affectées par les conflits et soutenir leur réinsertion sociale.
                    </p>
                    <br />
                  </div>
                </div>

                {/* Sponsoring & entreprises */}
                <div className="col-md-4 project-card shadow-sm border-0 h-100 p-2">
                  <div className="container bg-info rounded-4">
                    <div className="icon mb-3 text-white fs-1">
                      <i className="fas fa-handshake"></i>
                    </div>
                    <h5 className="fw-bold text-white">Sponsoring & Entreprises</h5>
                    <p className="text-white">
                      Soutien matériel, logistique ou financier des entreprises pour
                      permettre le développement des infrastructures, équipements et événements sportifs.
                    </p>
                    <br />
                  </div>
                </div>
              </div>

              {/* CONTENU HTML DEPUIS LA BD */}
              <div className="col-lg-12 p-lg-12 mt-4">
                <div dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.partenariat ?? '')
                }} />
              </div>

              {/* APPEL À ACTION */}
              <div className="bg-light p-4 rounded shadow-sm text-center mt-2">
                <h4 className="fw-bold">Vous souhaitez devenir partenaire ?</h4>
                <p className="text-muted mb-4">
                  Notre équipe est disponible pour étudier toute proposition de collaboration ou de soutien.
                </p>
                <Link to="/contact" className="btn btn-primary rounded-pill px-4 py-2">
                  <i className="fas fa-envelope-open-text me-2"></i>
                  Nous contacter
                </Link>
              </div>

              {/* LISTE DES PARTENAIRES */}
              <div className="mt-5">
                <Partenaire />
              </div>

            </div>
          </div>
        ))
      )}

    </div>


  )
}

